import React, { Component } from 'react';
import { injectIntl } from 'react-intl';

import messages from './AnnouncementView.intl';
import styles from './AnnouncementView.module.scss';
import { observer } from 'mobx-react';

import { Container, Title } from 'common/components/Layout/Layout';
import Document from 'common/components/Document/Document';

import ContentStore from 'stores/Content.store';
// import InjectMetaTags from 'common/components/InjectMetaTags/InjectMetaTags';

@injectIntl
@observer
export default class AnnouncementView extends Component {
  render() {
    const content = ContentStore.content;
    console.log('::content::', content);
    return (
      <>
        <div className={styles.AnnouncementsView}>
          {/* {ContentStore.isLoaded && (
            <InjectMetaTags {...content.announcementSEO} />
          )} */}
          <Container>
            <Title title={this.props.intl.formatMessage(messages.heading)} />
          </Container>
          {content && (
            <Container>
              <div className={styles.AnnouncementContent}>
                <p>{content.announcementFilesHeader}</p>
                {content.announcementFiles.map(item => (
                  <Document key={item.system.id} document={item} />
                ))}
              </div>
            </Container>
          )}
        </div>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Announcement/AnnouncementView.js